export enum ElementId {
  BackgroundOverlay = "BackgroundOverlay",
  BottomDrawerTitleRow = "BottomDrawerTitleRow",
  GoogleLoginButton = "GoogleLoginButton",
  ModalOutsideClick = "ModalOutsideClick",
}
